export default __webpack_public_path__ + "static/media/learose3-1024w.50f32939.avif";